import { EXPRESS_API } from 'configs/api/expressApi';
import { COOKIE_NAME } from 'configs/api/types';
import Cookies from 'js-cookie';
import { successToast } from 'lib/components/toasts/success';
import { THEME_NAME, useAuth, WHITELABELINFO } from 'lib/context';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

export interface LogoutUserParams {
  redirect?: string;
}

const logoutUser = async ({
  redirect = '',
}: LogoutUserParams): Promise<{ redirectUrl: string; token: string }> => {
  const response = await EXPRESS_API.post(
    '/auth/logout',
    {
      redirect,
    },
    { withCredentials: true }
  );
  return response.data;
};

export const useLogoutUser = (isSubUser = false) => {
  const { setJwtAndUpdateToken } = useAuth();

  const handleCdkLogout = () => {
    setJwtAndUpdateToken(
      {
        accessToken: Cookies.get(COOKIE_NAME.ADMIN_JWT) || '',
      },
      true
    );
    window.location.reload();
    return;
  };

  const { themeName } = useAuth();
  const { t } = useTranslation();
  return useMutation(logoutUser, {
    onSuccess: data => {
      if (!!isSubUser) {
        if (!!window.opener) {
          window.close();
        }

        if (themeName === THEME_NAME.CDK) {
          handleCdkLogout();
        } else {
          window.location.reload();
        }

        return;
      }
      if (themeName === THEME_NAME.CDK) {
        handleCdkLogout();
      }
      successToast({
        title: t(`User has been logged out successfully.`),
      });

      localStorage.setItem(WHITELABELINFO, '');
      if (data && data.redirectUrl) {
        window.location.href = data.redirectUrl;
      }
    },
  });
};
